import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import type { RumInitConfiguration } from "@datadog/browser-rum";

export const initializeDatadog = (): void => {
  // Skip initialization on localhost
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (isLocalhost) {
    console.info("Datadog RUM disabled on localhost environments");
    return;
  }

  const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID;
  const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
  const site = process.env.REACT_APP_DATADOG_SITE || "datadoghq.com";
  const service = process.env.REACT_APP_DATADOG_SERVICE || "office-react";
  const env = process.env.NODE_ENV;

  if (!applicationId || !clientToken) {
    console.warn(
      "Datadog RUM configuration is incomplete. Tracking will not be initialized."
    );
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: site as RumInitConfiguration["site"],
    service,
    env,
    version: process.env.REACT_APP_VERSION || "1.0.0",
    enableExperimentalFeatures: ["feature_flags"],
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    trackViewsManually: true,
    trackingConsent: "granted",
    beforeSend: () => {
      return true;
    },
    plugins: [reactPlugin],
  });
};

/**
 * Manually track route changes for hash router
 * @param pageName The name of the page/route
 */
export const trackRouteChange = (pageName: string): void => {
  if (datadogRum) {
    console.log("Datadog tracking route change:", pageName);

    // Send the view to Datadog RUM
    datadogRum.startView(pageName);

    // Optionally also add a custom user action for more visibility
    datadogRum.addAction("page_navigation", {
      page: pageName,
      timestamp: new Date().toISOString(),
    });
  }
};
